import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './Block.module.sass';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';

function Block(props) {
  const {
    color, text, onClick: onClickFromProps, active, editable, onInputChange, inputPlaceholder,
  } = props;

  const style = {
    borderColor: color,
  };

  if (active) {
    style.background = color;
  }

  const inputRef = useRef(null);

  const onClick = () => {
    onClickFromProps();

    if (!editable) { return; }

    inputRef.current.focus();
  };

  return (
    <ClickableDiv className={styles.block} onClick={onClick} style={style}>
      { !editable && (
        <div className={styles.text}>
          {text}
        </div>
      )}
      { editable && (
        <input type="text" ref={inputRef} placeholder={inputPlaceholder} value={text} onChange={onInputChange} />
      )}
    </ClickableDiv>
  );
}

Block.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  editable: PropTypes.bool,
  onInputChange: PropTypes.func,
  inputPlaceholder: PropTypes.string,
};

export default Block;
